import { trigger, transition, style, animate, AnimationTriggerMetadata } from '@angular/animations';

export interface ExpandInOptions {
  /** Timing string for the :enter transition (e.g. '300ms ease-in'). Defaults to '300ms ease-in'. */
  enterTiming?: string;
  /** Timing string for the :leave transition (e.g. '300ms ease-out'). Defaults to '300ms ease-out'. */
  leaveTiming?: string;
}

/**
 * Creates an expand/collapse animation that vertically expands the element
 * while fading in its content on :enter, and reverses on :leave.
 *
 * Usage:
 *   animations: [expandIn()]                                    // default 300ms
 *   animations: [expandIn({ enterTiming: '500ms ease' })]      // custom enter
 *   animations: [expandIn({ leaveTiming: '200ms ease-out' })]  // custom leave
 */
export function expandIn(options?: ExpandInOptions): AnimationTriggerMetadata {
  const enterTiming = options?.enterTiming ?? '300ms ease-in';
  const leaveTiming = options?.leaveTiming ?? '300ms ease-out';

  return trigger('expandIn', [
    transition(':enter', [
      style({ height: '0', overflow: 'hidden', opacity: 0 }),
      animate(enterTiming, style({ height: '*', overflow: 'hidden', opacity: 1 }))
    ]),
    transition(':leave', [
      style({ height: '*', overflow: 'hidden', opacity: 1 }),
      animate(leaveTiming, style({ height: '0', overflow: 'hidden', opacity: 0 }))
    ])
  ]);
}
